import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import axios from "axios";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import {
  removeFalsy,
  formatLocationIdForBackend,
  renameSqftForBackend,
} from "../helpers";
import { Typography } from "@material-ui/core";
import { Formik } from "formik";
import Grid from "@material-ui/core/Grid";
import * as yup from "yup";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Location from "./Location";
import FormErrorMessage from "./FormErrorMessage";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";

const styles = (theme) => ({
  textFieldAmount: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    maxWidth: "100%",
    width: 300,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    maxWidth: "100%",
    width: 300,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  movingFrom: {
    paddingBottom: theme.spacing(4),
  },
  scopeDialog: {
    textAlign: "center",
  },
  icon: {
    fontSize: "3.75rem",
  },
  dialogActions: {
    justifyContent: "center",
    paddingBottom: "1.5rem",
  },
});

class Locations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailModalOpen: false,
      scopeModalOpen: false,
      scopeModalSubmitted: false,
      emailSubmitted: false,
      values: {},
      actions: {},
    };
  }

  handleScopeModalOpen = () => {
    this.setState({ scopeModalOpen: true });
  };

  handleScopeModalClose = () => {
    this.setState({ scopeModalOpen: false });
  };

  handleEmailModalOpen = (values, actions) => {
    this.setState({
      emailModalOpen: true,
      values,
      actions,
    });
  };

  handleEmailModalClose = () => {
    this.setState({
      emailModalOpen: false,
    });
  };

  handleNextStep = (values, actions) => {
    // duplicate the object
    let valuesToSendToBackend = JSON.parse(JSON.stringify(values));

    valuesToSendToBackend = {
      ...valuesToSendToBackend,
      ...this.props.originDestinationFormValues,
      movingDateTime:
        typeof this.props.movingDateFormValues.date.toISOString == "function"
          ? this.props.movingDateFormValues.date.toISOString()
          : this.props.movingDateFormValues.date,
    };

    // remove the date
    // valuesToSendToBackend.date = null;

    // fix the location ids
    valuesToSendToBackend = formatLocationIdForBackend(valuesToSendToBackend);

    // Fix sqft values
    valuesToSendToBackend = renameSqftForBackend(valuesToSendToBackend);

    // remove any fields that are blank - from example https://coderwall.com/p/urxpsa/remove-falsy-values-or-empty-strings-from-javascript-objects
    valuesToSendToBackend = removeFalsy(valuesToSendToBackend);

    valuesToSendToBackend.name = this.props.name;
    valuesToSendToBackend.email = this.props.email;
    valuesToSendToBackend.phone = this.props.phone;
    valuesToSendToBackend.uuid = this.props.uuid;
    valuesToSendToBackend.locationsFormValues = JSON.stringify(values);
    valuesToSendToBackend.movingDateFormValues = JSON.stringify(
      this.props.MovingDateFormValues
    );
    valuesToSendToBackend.originDestinationFormValues = JSON.stringify(
      this.props.OriginDestinationFormValues
    );

    this.props.setEstimateValues(valuesToSendToBackend);

    // then send
    return axios
      .request({
        method: "post",
        url: runtimeEnv().REACT_APP_API_URL + "/estimate",
        data: valuesToSendToBackend,
      })
      .then((response) => {
        actions.setSubmitting(false);
        this.setState({
          emailSubmitted: true,
        });
        this.props.updateQuote({
          ...response.data,
          amount_off: 0,
          percent_off: 0,
        });
        this.props.handleNext(values);
      })
      .catch((error) => {
        actions.setSubmitting(false);

        if (error.response.data.message === "Estimated Duration is too long.") {
          this.values = valuesToSendToBackend;
          this.handleScopeModalOpen();
        } else {
          actions.setErrors(error.response.data.fields || {});
          actions.setStatus({ message: error.response.data.message });

          console.log(error); //eslint-disable-line no-console
          console.log(error.response); //eslint-disable-line no-console
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Formik
          validateOnChange={true}
          validationSchema={yup.object({
            originTypeOf: yup.string().label("Type of home").required(),
            originUnitNumber: yup
              .string()
              .label("Unit number")
              .when("originTypeOf", {
                is: (originTypeOf) =>
                  originTypeOf === "apt" || originTypeOf === "storage",
                then: yup.string().optional(),
                otherwise: yup.string(),
              }),
            originSqFt: yup
              .string()
              .label("Bedrooms")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "house",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            originSqFtApt: yup
              .string()
              .label("Bedrooms")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "apt",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            originSqFtMiniStorage: yup
              .string()
              .label("Sq ft")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "storage",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            originFloor: yup
              .number()
              .positive()
              .integer()
              .label("Floor")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "apt",
                then: yup.number().required(),
                otherwise: yup.number(),
              }),
            originNumFloors: yup
              .number()
              .positive()
              .label("Floors")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "house",
                then: yup.number().required(),
                otherwise: yup.number(),
              }),
            originElevator: yup
              .string()
              .label("Elevator")
              .when("originTypeOf", {
                is: (originTypeOf) => originTypeOf === "apt",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            destinationTypeOf: yup.string().label("Type of home").required(),
            destinationUnitNumber: yup
              .string()
              .label("Unit number")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) =>
                  destinationTypeOf === "apt" ||
                  destinationTypeOf === "storage",
                then: yup.string().optional(),
                otherwise: yup.string(),
              }),
            destinationSqFt: yup
              .string()
              .label("Bedrooms")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "house",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            destinationSqFtApt: yup
              .string()
              .label("Bedrooms")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "apt",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            destinationSqFtMiniStorage: yup
              .string()
              .label("Sq ft")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "storage",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            destinationFloor: yup
              .number()
              .positive()
              .integer()
              .label("Floor")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "apt",
                then: yup.number().required(),
                otherwise: yup.number(),
              }),
            destinationNumFloors: yup
              .number()
              .positive()
              .label("Floors")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "house",
                then: yup.number().required(),
                otherwise: yup.number(),
              }),
            destinationElevator: yup
              .string()
              .label("Elevator")
              .when("destinationTypeOf", {
                is: (destinationTypeOf) => destinationTypeOf === "apt",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
            amountOfStuff: yup.string().label("Amount of stuff").required(),
            itemsIn: yup
              .string()
              .label("Items in...")
              .when("originTypeOf", {
                is: (originTypeOf) =>
                  originTypeOf === "apt" || originTypeOf === "house",
                then: yup.string().required(),
                otherwise: yup.string(),
              }),
          })}
          initialValues={
            (!(
              Object.entries(this.props.values).length === 0 &&
              this.props.values.constructor === Object
            ) &&
              this.props.values) || {
              //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
              originTypeOf: "",
              originUnitNumber: "",
              originSqFt: "",
              originSqFtApt: "",
              originSqFtMiniStorage: "",
              originFloor: "",
              originNumFloors: "",
              originElevator: "",
              destinationTypeOf: "",
              destinationUnitNumber: "",
              destinationSqFt: "",
              destinationSqFtApt: "",
              destinationSqFtMiniStorage: "",
              destinationFloor: "",
              destinationNumFloors: "",
              destinationElevator: "",
              amountOfStuff: "",
              itemsIn: "",
            }
          }
          onSubmit={(values, actions) => {
            window.dataLayer.push({
              event: "get-price",
              eventProps: {
                category: "Ecommerce",
                action: "Click",
                label: "Page 4 - Get Price",
              },
            });

            if (!this.props.name) {
              this.handleEmailModalOpen(values, actions);
            } else {
              this.handleNextStep(values, actions);
            }
          }}
        >
          {({
            values,
            errors,
            status,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid>
                {status && status.message && (
                  <FormErrorMessage message={status.message} />
                )}

                <Grid className={classes.movingFrom}>
                  <Typography variant="h6" component="h6">
                    Where are you moving from?
                  </Typography>

                  <Location
                    name="origin"
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    isSubmitting={isSubmitting && this.state.emailModalOpen}
                  />

                  <TextField
                    name={"amountOfStuff"}
                    select
                    label="I'm moving..."
                    className={classes.textFieldAmount}
                    disabled={isSubmitting && this.state.emailModalOpen}
                    value={values["amountOfStuff"]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched["amountOfStuff"] && errors["amountOfStuff"]
                    }
                    error={
                      touched["amountOfStuff"] && !!errors["amountOfStuff"]
                    }
                    margin="normal"
                    variant="outlined"
                  >
                    <MenuItem value={"1"}>just a few items</MenuItem>
                    <MenuItem value={"2"}>
                      furniture and large items only
                    </MenuItem>
                    <MenuItem value={"3"}>all of my items</MenuItem>
                  </TextField>
                </Grid>
                <Grid className={classes.movingFrom}>
                  <Typography variant="h6" component="h6">
                    Where are you moving to?
                  </Typography>

                  <Location
                    name="destination"
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    isSubmitting={isSubmitting && this.state.emailModalOpen}
                  />
                </Grid>
              </Grid>
              <NextBackButtons
                backOnClick={this.props.handleBack}
                disableBoth={isSubmitting && this.state.emailModalOpen}
                nextLabel="Get Price"
              />
              <ResponsiveMobileStepper
                steps={this.props.steps}
                activeStep={this.props.activeStep}
                backOnClick={this.props.handleBack}
                nextLabel="Get Price"
              />
            </form>
          )}
        </Formik>

        <Dialog
          open={this.state.scopeModalOpen}
          onClose={this.handleScopeModalClose}
          aria-labelledby="scope-dialog-title"
          aria-describedby="scope-dialog-description"
          className={classes.scopeDialog}
        >
          {!this.state.scopeModalSubmitted && (
            <Formik
              validateOnChange={true}
              validationSchema={yup.object({
                email: yup.string().email().label("Email").required(),
              })}
              initialValues={{
                email: "",
              }}
              onSubmit={(values, actions) => {
                // duplicate the object
                let valuesToSendToBackend = JSON.parse(JSON.stringify(values));

                valuesToSendToBackend = {
                  ...valuesToSendToBackend,
                  ...this.values,
                  ...this.props.originDestinationFormValues,
                  movingDateTime:
                    typeof this.props.movingDateFormValues.date.toISOString ==
                    "function"
                      ? this.props.movingDateFormValues.date.toISOString()
                      : this.props.movingDateFormValues.date,
                };

                // remove the date
                // valuesToSendToBackend.date = null;

                // fix the location ids
                valuesToSendToBackend = formatLocationIdForBackend(
                  valuesToSendToBackend
                );

                // Fix sqft values
                valuesToSendToBackend = renameSqftForBackend(
                  valuesToSendToBackend
                );

                // remove any fields that are blank - from example https://coderwall.com/p/urxpsa/remove-falsy-values-or-empty-strings-from-javascript-objects
                valuesToSendToBackend = removeFalsy(valuesToSendToBackend);

                return (
                  axios
                    .request({
                      method: "post",
                      url: runtimeEnv().REACT_APP_API_URL + "/leads/outofscope",
                      data: valuesToSendToBackend,
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then((response) => {
                      actions.setSubmitting(false);
                      this.setState({ scopeModalSubmitted: true });
                    })
                    .catch((error) => {
                      actions.setSubmitting(false);
                      actions.setErrors(error.response.data.fields || {});
                      actions.setStatus({
                        message: error.response.data.message,
                      });

                      console.log(error); //eslint-disable-line no-console
                      console.log(error.response); //eslint-disable-line no-console
                    })
                );
              }}
            >
              {({
                values,
                errors,
                status,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                // eslint-disable-next-line no-unused-vars
                setFieldValue,
                // eslint-disable-next-line no-unused-vars
                setFieldError,
                isSubmitting,
              }) => (
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <DialogTitle id="scope-dialog-title">
                    We&#39;re Sorry
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="range-dialog-description">
                      Your move requires multiple days&#39; work.
                    </DialogContentText>
                    <DialogContentText id="range-dialog-description2">
                      Please provide your contact information and one of our
                      moving buddies will get in touch.
                    </DialogContentText>
                    {status && status.message && (
                      <FormErrorMessage message={status.message} />
                    )}
                    <TextField
                      name={"email"}
                      label="Email"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.email && errors.email}
                      error={touched.email && !!errors.email}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Notify me
                    </Button>
                  </DialogActions>
                  <DialogContent>
                    <DialogContentText id="range-dialog-description3">
                      <strong>Prefer to contact us?</strong>
                    </DialogContentText>
                    <DialogContentText id="range-dialog-description4">
                      <Button
                        startIcon={<PhoneIcon color="primary" />}
                        color="primary"
                        href="tel:440.785.2567"
                      >
                        440.785.2567
                      </Button>
                    </DialogContentText>
                    <DialogContentText id="range-dialog-description5">
                      <Button
                        startIcon={<EmailIcon color="primary" />}
                        color="primary"
                        href="mailto:support@gomovingbuddy.com"
                      >
                        support@gomovingbuddy.com
                      </Button>
                    </DialogContentText>
                  </DialogContent>
                </form>
              )}
            </Formik>
          )}
          {this.state.scopeModalSubmitted && (
            <>
              <DialogTitle id="scope-dialog-title">Thanks</DialogTitle>
              <DialogContent>
                <CheckCircleIcon className={classes.icon} color="primary" />
              </DialogContent>
              <DialogContent>
                <DialogContentText id="scope-dialog-description">
                  We&#39;ll be in touch
                </DialogContentText>
              </DialogContent>
            </>
          )}
        </Dialog>

        <Dialog
          open={this.state.emailModalOpen}
          onClose={this.handleEmailModalClose}
          aria-labelledby="scope-dialog-title"
          aria-describedby="scope-dialog-description"
          className={classes.scopeDialog}
        >
          <Formik
            validateOnChange={true}
            validationSchema={yup.object({
              email: yup.string().email().label("Email").required(),
              phone: yup.string().label("Phone").required(),
            })}
            initialValues={{
              email: this.props.email,
              name: this.props.name,
              phone: this.props.phone,
            }}
            // eslint-disable-next-line no-unused-vars
            onSubmit={(values, actions) => {
              window.dataLayer.push({
                event: "enter-email-name",
                eventProps: {
                  category: "Ecommerce",
                  action: "Click",
                  label: "Page 4a enter email and name",
                },
              });

              let valuesToSend = JSON.parse(JSON.stringify(values));
              const timestamp = Number(new Date());
              const date = new Date(timestamp);
              valuesToSend.date = date;
              this.props.setName(valuesToSend.name);
              this.props.setEmail(valuesToSend.email);
              this.props.setPhone(valuesToSend.phone);
              this.handleEmailModalClose();
              this.handleNextStep(this.state.values, this.state.actions);
              return;
            }}
            render={({
              values,
              errors,
              // eslint-disable-next-line no-unused-vars
              status,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
              // eslint-disable-next-line no-unused-vars
              setFieldValue,
              // eslint-disable-next-line no-unused-vars
              setFieldError,
              // eslint-disable-next-line no-unused-vars
              isSubmitting,
            }) => (
              <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <DialogTitle>Save Your Quote</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Please provide your contact information and we'll send you a
                    copy of your quote to help get you moving!
                  </DialogContentText>
                  <TextField
                    name={"name"}
                    label="Name"
                    className={classes.textField}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                  />
                  <TextField
                    name={"phone"}
                    label="Phone #"
                    className={classes.textField}
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.phone && errors.phone}
                    error={touched.phone && !!errors.phone}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                  />
                  <TextField
                    name={"email"}
                    label="Email"
                    className={classes.textField}
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={touched.email && errors.email}
                    error={touched.email && !!errors.email}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                  />
                  <DialogContentText>
                    <em>
                      * Your email and phone will only be used for communication
                      with Moving Buddy. Your details are safe with us.
                    </em>
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={this.state.isSubmittingEmail}
                  >
                    Get Price
                  </Button>
                </DialogActions>
              </form>
            )}
          />
        </Dialog>
      </>
    );
  }
}

Locations.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  originDestinationFormValues: PropTypes.object.isRequired,
  movingDateFormValues: PropTypes.object.isRequired,
  updateQuote: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  setPhone: PropTypes.func.isRequired,
  MovingDateFormValues: PropTypes.any.isRequired,
  OriginDestinationFormValues: PropTypes.any.isRequired,
  setEstimateValues: PropTypes.func.isRequired,
};

export default withStyles(styles)(Locations);
